import { type ProgramEventContentObjectDetail, createEventContentObject, isNodeEventContentObject } from 'models';
import { useQuery } from 'query';
import type { EventContentObjectDataObject } from 'models/service';
import { getEvent } from '../services';
import { getProgramEventLayoutQueryKey } from './keys';

export type ProgramEventLayoutQueryData = { nodeId: string } | ProgramEventContentObjectDetail;

export const useProgramEventLayoutQuery = ({ eventId }: { eventId: string }) =>
  useQuery<ProgramEventLayoutQueryData>({
    async queryFn() {
      const { data: eventContentObject } = await getEvent<EventContentObjectDataObject>(eventId);

      if (eventContentObject.event.meta?.node_id) {
        return { nodeId: eventContentObject.event.meta.node_id };
      }

      const contentObject = createEventContentObject(eventContentObject);

      return isNodeEventContentObject(contentObject) ? { nodeId: contentObject.event.id } : contentObject;
    },
    queryKey: getProgramEventLayoutQueryKey({ id: eventId }),
    throwOnError: false,
  });
